import { Button, Tag } from "antd";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import { IntegrationOrderVo } from "@/types/integration";
import { InstaOrderRequestRaw } from "@/components/integration/order/raw/InstaOrder";
import classNames from "classnames";

interface OrderListItemProps {
  order: IntegrationOrderVo;
  expanded?: boolean;
  onToggleExpand?: () => void;
  action: React.ReactNode;
  className?: string;
}

export default function B2BOrderItem({
  order,
  expanded,
  onToggleExpand,
  action,
  className,
}: OrderListItemProps) {
  return (
    <div
      className={classNames(
        "border border-gray-200 rounded-md mb-1.5",
        className,
      )}
    >
      <div className="flex items-center gap-2 px-3 py-2">
        {onToggleExpand && (
          <Button
            type="text"
            size="small"
            icon={expanded ? <DownOutlined /> : <RightOutlined />}
            onClick={onToggleExpand}
          />
        )}
        <div className="flex-1 flex items-center gap-2 min-w-0">
          <span className="font-medium truncate">
            {order.customerNumber} ({order.cubeDeliveryNo})
          </span>
          {(order?.extra["platform"] as string) && (
            <Tag className="!mr-0" color="blue">
              {order.extra["platform"] as string}
            </Tag>
          )}
          <Tag className="!mr-0" color="blue">
            {order.warehouseCode}
          </Tag>
        </div>
        {action}
      </div>
      {expanded && (
        <div className="px-3 pt-2 pb-2 border-t border-gray-100 bg-gray-50">
          <InstaOrderRequestRaw
            rawData={order.extra}
            column={1}
            labelStyle={{ width: "30%" }}
            contentStyle={{ width: "70%" }}
          />
        </div>
      )}
    </div>
  );
}
